var styles = {"singleSelect":"MenuList-module_singleSelect__ZIadq","active":"MenuList-module_active__Bpd2x","menuListOption":"MenuList-module_menuListOption__a46Bt","menuItem":"MenuList-module_menuItem__m3kS0","loaderWrapper":"MenuList-module_loaderWrapper__a-7MN","loader":"MenuList-module_loader__y-mmS","textBox":"MenuList-module_textBox__BZ-q9"};

export { styles as default };
